<template>
  <a-modal title="关联单" class="relevance-order-modal" :visible="visible" :footer="null" @cancel="handleCancel">
    <div>
      <a-table :loading="{  spinning: $store.state.tabLoding, indicator:indicator }" :columns="columns" :dataSource="dataSource" :pagination="false" bordered :scroll="{y: 420 }" key="id">
        <!-- 删除 -->
        <template slot="operation" slot-scope="text, record, index">
          <span class="set-goods" @click="btnOrderDetails(text, record, index)">查看</span>
        </template>
      </a-table>
    </div>
  </a-modal>
</template>
<script>
import { getListMethod } from "@/utils/api"
export default {
  name: 'relevanceOrder',
  data () {
    return {
      visible: false,
      columns: [
        {
          width: 220,
          title: '单据编号',
          dataIndex: 'code',
          key: 'code',
        }, {
          title: '单据类型',
          dataIndex: 'orderType',
          key: 'orderType',
        }, {
          title: '单据时间',
          dataIndex: 'voucherDate',
          key: 'voucherDate',
        }, {
          title: '经办人',
          dataIndex: 'transactorName',
          key: 'transactorName',
        }, {
          title: '摘要',
          dataIndex: 'digest',
          key: 'digest',
        }, {
          title: '备注',
          dataIndex: 'remark',
          key: 'remark',
        }, {
          title: '操作',
          key: 'operation',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
        }
      ],
      dataSource: [],
      relevanceId: '',
      urlList: {
        inurl: '/storage/api/inbound/listBusinessVoucherByInboundId',
        outurl: '/storage/api/outbound/listBusinessVoucherByOutboundId'
      },
      type: null,
      voucherId: [],
      goodsList: [],
      isLoding: false,
      indicator: '<a-icon type="loading" style="font-size: 24px" spin />'
    }
  },
  methods: {
    open (id, type) {
      this.visible = true
      this.type = type
      this.relevanceId = id
      this.getGoodsList()
    },
    handleCancel () {
      this.visible = false
    },
    // 获取表格数据
    getGoodsList () {
      this.$store.state.tabLoding = true
      let params = {}
      let header = {}
      let data = {}
      let url = this.urlList.inurl
      if (this.type == 1 || this.type == 2) {
        url = this.urlList.inurl
        data = {
          companyStoreId: this.$store.state.userInfo.companyStoreId,
          inboundId: this.relevanceId
        }
      } else if (this.type == 5 || this.type == 6) {
        url = this.urlList.outurl
        data = {
          companyStoreId: this.$store.state.userInfo.companyStoreId,
          outboundId: this.relevanceId
        }
      }
      getListMethod(url, params, header, data).then((res) => {
        if (res.success) {
          if (res.result) {
            res.result.map(item => {
              if (this.type == 1) {
                item.orderType = '采购订单'
              } else if (this.type == 2) {
                item.orderType = '销售出库单'
              } else if (this.type == 5) {
                item.orderType = '销售订单'
              } else if (this.type == 6) {
                item.orderType = '采购入库单'
              }
            })
            this.dataSource = res.result
          }
          this.$store.state.tabLoding = false
        }
      })
    },
    // 查看详情
    btnOrderDetails (text, record, index) {
      if (this.type == 1) {
        this.$router.push({ path: '/purchase/purchaseasmin/purchaseOrderLook?id=' + record.id })
      } else if (this.type == 2) {
        this.$router.push({ path: '/bill/modules/billMarket?voucherEntityId=' + record.id + '&conceal=1' })
      } else if (this.type == 5) {
        this.$router.push({ path: '/sales/selladmin/sellOrderLook/?id=' + record.id })
      } else if (this.type == 6) {
        this.$router.push({ path: '/bill/modules/billPurchase?voucherEntityId=' + record.id + '&conceal=1' })
      }
      this.visible = false
    }
  }
}
</script>
<style lang="scss">
.relevance-order-modal {
  width: 1085px !important;
  height: 675px !important;
  .ant-modal-body {
    padding: 0 24px 24px 24px !important;
    .ant-table-tbody {
      td {
        background: #ffffff !important;
      }
    }
    .set-goods {
      color: #377bfb;
      cursor: pointer;
    }
  }
  .ant-table-wrapper {
    border: 1px solid #f0f0f0;
    // border-bottom: 0;
  }
  .ant-modal-footer {
    padding: 0 0 30px 0;
  }
}
</style>
